import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '@/resources/upgrade/jsonapi-client';
import { ILoginData, ISession } from '@/resources/upgrade/Session';

interface ILoginMutationOptions {
  onSuccess?: (session: ISession) => void;
  onFailure?: (error: Error) => void;
}

export function useLoginMutation(options?: ILoginMutationOptions) {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    // Single resource - kitsu hoists data directly
    mutationFn: (data: ILoginData) => apiClient.post<ISession>('sessions', data, { include: 'user,main_profile' }),
    onSuccess: async (session) => {
      await queryClient.invalidateQueries({
        queryKey: ['sessions', 'me'],
      });

      options?.onSuccess?.(session);
    },
    onError: (error: Error) => {
      options?.onFailure?.(error);
    },
  });

  return [mutation.mutate, mutation] as const;
}
